<template>
  <div
    class="flex flex-col-reverse md:flex-row flex-wrap justify-center items-center"
  >
    <div class="flex-1 w-full md:w-1/5 flex justify-center items-center">
      <svg-inline
        class="md:absolute md:bottom-5 md:left-5 w-36 md:w-80 mt-5"
        style="color:#6c63ff"
        image="undraw/undraw_Around_the_world_re_n353"
      />
    </div>

    <div class="z-10 w-full md:w-3-5 flex flex-col justify-center items-center">
      <div
        class="text-center text-2xl md:text-4xl font-bold text-purple-600"
        style=""
      >
        appflowz
      </div>

      <div
        class="norm-card shadow-none md:shadow-lg p-7 mt-5 md:mt-10 mx-0 sm:mx-5 mb-5"
        style="max-width:26em"
      >
        <div
          class="text-center text-md md:text-lg text-gray-500 font-bold mb-5"
        >
          Log in to your account
        </div>

        <BaseFormErrors :errors="errors" />

        <div class="form-body">
          <form @submit.prevent="submit" class="register">
            <input
              v-model="email"
              type="email"
              name="email"
              placeholder="Email Address"
              value
            />

            <input
              v-model="password"
              type="password"
              name="password"
              placeholder="Password"
              value
            />

            <p class="text-center">
              A journey of a thousand miles begins with the first step.
            </p>

            <button type="submit" name="button" class="submit p-2 text-white">
              <span v-if="isLoading" class="spinner-white"></span>
              <span v-else>Log In</span>
            </button>
          </form>
        </div>
        <div class="rule"></div>
        <div class="mt-5 text-center">
          <router-link :to="{ name: 'user-register' }" class="small-link">
            Sign up for an account
          </router-link>
          |
          <router-link :to="{ name: 'forgot-password' }" class="small-link">
            Forgot your password?
          </router-link>
        </div>
      </div>
    </div>

    <div class="flex-1 w-full md:w-1/5 flex justify-center items-center">
      <svg-inline
        class="md:absolute md:bottom-5 md:right-5 w-36 md:w-80 mt-5"
        style="color:#6c63ff"
        image="undraw/undraw_among_nature_p1xb"
      />
    </div>
  </div>
</template>

<script>
import { ConsoleLogApiErrors } from "@/mixins/Mixins.js";
import { FormValidator } from "@/mixins/FormValidator.js";

export default {
  mixins: [ConsoleLogApiErrors, FormValidator],
  data() {
    return {
      email: "",
      password: "",
      errors: [],
      isLoading: false,
    };
  },
  validations: {
    email: {
      required: true,
      isEmail: true,
      maxLength: 255,
    },
    password: {
      required: true,
      maxLength: 255,
    },
  },
  methods: {
    async submit() {
      if (this.validateForm()) {
        this.isLoading = true;
        this.$store
          .dispatch("auth/signIn", {
            email: this.email,
            password: this.password,
          })
          .then(() => {
            if (this.$gtm.enabled()) {
              console.log('gtm loaded ' + this.email)
              window.dataLayer?.push({
                'event': "login",
                'user_email': this.email,
                // further parameters
              });
            } 

            this.isLoading = false;
            this.$router.push({ name: "home" });
          })
          .catch((err) => {
            this.ConsoleLogApiErrors(err);
            this.errors = err.response.data.error;
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.norm-card {
  border-radius: 5px;
  background: white;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.3),
    1px 1px 20px 14px rgba(0, 0, 0, 0.15);

  .card-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 17px;
    font-weight: bold;
    background: #e7e9e7;
    border-radius: 5px 5px 0 0;
    color: rgb(90, 86, 86);
  }

  .form-title {
    font-weight: bold;
    font-size: 16px;
    margin: 20px 0 10px 0;
    color: #4e5a6b;
    font-weight: 800;
    letter-spacing: 0.4px;
  }

  .form-body {
    justify-content: space-around;

    p {
      padding: 5px 0px;
      color: #576366;
      font-size: 12px;
      margin: 10px auto 0 auto;
    }

    button.submit {
      background: #22b958;
      width: 100%;
    }
  }

  .rule {
    height: 2px;
    background: #e8ebed;
    margin: 15px 35px;
  }

  input[type="text"],
  input[type="email"],
  input[type="password"] {
    appearance: none;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
    height: 45px;
    padding: 5px 15px;
    border-radius: 3px;
    outline: none;
    border: 2px solid #dbe2ef;
    background: #e8f0fe;
    color: #333333;
    font-size: 14px;
  }
}

input:focus {
  background-color: white;
  border: 2px solid rgb(76, 154, 255);
}

label {
  appearance: none;
  margin-left: 1px;
  font-size: 15px;
  color: #696565;
  margin-bottom: 5px;
  display: block;
}
</style>
